import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { apiFetch, clearAccessToken } from "./api";

export default function AdminRoute({ children }) {
    const location = useLocation();
    const [state, setState] = useState({
        loading: true,
        authenticated: false,
        admin: false
    });

    useEffect(() => {
        let active = true;

        (async () => {
            try {
                const res = await apiFetch(
                    "/api/auth/me",
                    {},
                    { autoRedirectOn401: false }
                );

                if (!active) return;

                if (res.status === 401) {
                    clearAccessToken(true);
                    setState({
                        loading: false,
                        authenticated: false,
                        admin: false
                    });
                    return;
                }

                if (!res.ok) {
                    setState({
                        loading: false,
                        authenticated: true,
                        admin: false
                    });
                    return;
                }

                const data = await res.json();

                setState({
                    loading: false,
                    authenticated: true,
                    admin: data?.isAdmin === true
                });
            } catch {
                if (!active) return;

                setState({
                    loading: false,
                    authenticated: false,
                    admin: false
                });
            }
        })();

        return () => {
            active = false;
        };
    }, []);

    if (state.loading) {
        return null;
    }

    if (!state.authenticated) {
        return <Navigate to="/vpis" replace state={{ from: location }} />;
    }

    if (!state.admin) {
        return <Navigate to="/profil" replace />;
    }

    return children;
}